import {
    DetailGroupActionTab,
    DetailGroupStatistic,
    DetailGroupStudentTable,
    LearningProgress,
} from './components';
import { GroupMetricsDiagrams } from 'src/pages/edu/GroupPage/components/GroupMetricsDiagrams/GroupMetricsDiagrams';
import {
    useGetGroupByIdQuery,
    useGetGroupLearningProgressQuery,
    useGetGroupStudentsQuery,
} from 'src/api';
import { useGetGroupMetricsQuery } from 'src/api/endpoints/group/metrics/metrics.api';
import { StudentLayout } from 'src/components/Layout/student/StudentLayout';
import { FC, ReactElement, useEffect, useState } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Loader from 'src/components/Loader';
import { AuthorizedUserProps } from 'src/routes/components/PrivateRoute';

export const GroupPage: FC<AuthorizedUserProps> = (props: AuthorizedUserProps): ReactElement => {
    const groupId: number = Number(useParams().groupId);

    const [pageLoaded, setPageLoaded] = useState<boolean>(false);

    const { data, isLoading: groupIsLoading } = useGetGroupByIdQuery(groupId);
    const {
        data: groupLearningProgress,
        isLoading: learningProgressIsLoading,
    } = useGetGroupLearningProgressQuery(groupId);
    const { data: groupMetrics, isLoading: metricsIsLoading } =
        useGetGroupMetricsQuery({ groupId });

    const {
        data: students,
        isLoading: studentsIsLoading,
        isFetching,
    } = useGetGroupStudentsQuery({ params: { groupId } });

    useEffect(() => {
        setPageLoaded(
            groupIsLoading ||
                learningProgressIsLoading ||
                metricsIsLoading ||
                studentsIsLoading
        );
    }, [
        learningProgressIsLoading,
        studentsIsLoading,
        metricsIsLoading,
        groupIsLoading,
    ]);

    return (
        <StudentLayout auth={props}>
            <Helmet title={'Группы'} />
            <main>
                {pageLoaded ||
                !data ||
                !groupLearningProgress ||
                !groupMetrics ? (
                    <Loader />
                ) : (
                    <>
                        <div className="grid ml-0 mr-0">
                            <div className="col-12 lg:col-8">
                                <DetailGroupActionTab group={data} />
                            </div>
                            <div className="col-12 lg:col-4">
                                {groupLearningProgress && (
                                    <LearningProgress
                                        total={groupLearningProgress.total}
                                        learned={groupLearningProgress.learned}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="grid ml-0 mr-0 media-md-mt-24">
                            <div className="col-12 lg:col-8 p-0">
                                <div className="col-12">
                                    <DetailGroupStatistic group={data} />
                                </div>
                                <GroupMetricsDiagrams
                                    branch={props.currentBranchId}
                                    groupId={groupId}
                                    metrics={groupMetrics}
                                />
                            </div>
                            <div className="col-12 lg:col-4">
                                <DetailGroupStudentTable
                                    branch={props.currentBranchId}
                                    group={data}
                                    students={students ?? []}
                                    isFetching={isFetching}
                                />
                            </div>
                        </div>
                    </>
                )}
            </main>
            <ConfirmDialog />
        </StudentLayout>
    );
};
